module.exports = __webpack_public_path__ + "assets/img/media-the-buzz.8217513c.svg";